<template>
  <div></div>
</template>

<script lang="ts" setup>
import { useAuthStore } from '@/stores/login'
import { isFeishu } from '@/utils/feishu'
import { getH5Url } from '@/utils/urlMapping'
import { onMounted, ref } from 'vue'

interface JumpModuleIdProps {
  commentModuleId?: string
  commentId?: string
  certificateUserId?: string
}

const stsJumpUrl = ref('')
const { setAppId } = useAuthStore()

onMounted(() => {
  if (isFeishu) {
    const queryString = window.location.href.split('?')[1]

    // 将参数部分解析为URLSearchParams对象
    const urlParams = new URLSearchParams(queryString)
    const state = urlParams.get('state')
    const jumpType = urlParams.get('jumpType')
    const jumpModuleId = urlParams.get('jumpModuleId')
    const jumpAppId = urlParams.get('appId')
    const customTemplateId = urlParams.get('customTemplateId') || ''
    console.log(
      '飞书跳转参数:============',
      `state:${state}`,
      `jumpType:${jumpType}`,
      `jumpModuleId:${jumpModuleId}`,
      `jumpAppId:${jumpAppId}`,
      `customTemplateId:${customTemplateId}`
    )

    setAppId('')
    jumpAppId && setAppId(jumpAppId)
    if (state === 'feishu_jump' && jumpType && jumpModuleId) {
      if (jumpType === '1202') {
        // 证书
        feishuJump(jumpType, jumpModuleId, customTemplateId || '')
      } else {
        feishuJump(jumpType, jumpModuleId, customTemplateId || '')
      }
    }
  }
})

const feishuJump = (jumpType: string, jumpModuleId: string | JumpModuleIdProps, customTemplateId?: string) => {
  // 使用动态URL生成函数替代硬编码的环境判断
  stsJumpUrl.value = getH5Url()
  // 100 资讯
  // 202 课程
  // 300 考试
  // 400 调查
  // 500 项目列表
  // 600 CEO
  // 700 直播
  // 1900 勋章
  // 803 贴子
  // 1200 积分
  // 消息推送：1300 自定义消息 1301 自定义链接
  //  1400 练习
  // 1600 面授
  switch (jumpType) {
    case '4':
    case '100':
    case '101':
    case '1300':
    case '1301':
      if (jumpType === '101') {
        if (jumpModuleId) {
          window.location.replace(`${stsJumpUrl.value}broadcastDetail/${jumpModuleId}?topId=${customTemplateId}`)
        } else {
          window.location.replace(`${stsJumpUrl.value}broadcastDetail/${jumpModuleId}?jumpType=${jumpType}`)
        }
      } else {
        window.location.replace(`${stsJumpUrl.value}broadcastDetail/${jumpModuleId}?jumpType=${jumpType}`)
      }
      break
    case '201':
      window.location.replace(
        `${stsJumpUrl.value}courseDetail?id=${jumpModuleId}&courseId=&courseType=course&endingType=0&channel=0`
      )
      break
    case '18':
    case '200':
    case '202':
      window.location.replace(`${stsJumpUrl.value}courseDetail?id=${jumpModuleId}&courseType=courseWare`)
      break
    case '203':
      window.location.replace(
        `${stsJumpUrl.value}courseDetail?id=${jumpModuleId}&topId=${customTemplateId}&courseType=course`
      )
      break
    case '204':
      window.location.replace(
        `${stsJumpUrl.value}courseDetail?id=${jumpModuleId}&topId=${customTemplateId}&courseType=courseWare`
      )
      break
    case '303':
      window.location.replace(`${stsJumpUrl.value}examDetail?id=${jumpModuleId}&studyType=2`)
      break
    case '401':
      window.location.replace(`${stsJumpUrl.value}surveyDetail?id=${jumpModuleId}&studyType=3`)
      break
    case '503':
      window.location.replace(`${stsJumpUrl.value}projectDetail?id=${jumpModuleId}&studyType=1`)
      break
    case '6':
    case '300':
    case '301':
      window.location.replace(`${stsJumpUrl.value}examInfo?examId=${jumpModuleId}`)
      break
    case '7':
    case '400':
      window.location.replace(`${stsJumpUrl.value}surveyInfo?investigationId=${jumpModuleId}`)
      break
    case '5':
    case '500':
      window.location.replace(`${stsJumpUrl.value}trainingDetail?id=${jumpModuleId}`)
      break
    case '600':
      window.location.replace(`${stsJumpUrl.value}CeoDetail?id=${jumpModuleId}`)
      break
    case '700':
      window.location.replace(`${stsJumpUrl.value}liveStreamTrans?id=${jumpModuleId}`)
      break
    case '802':
      if (jumpModuleId) {
        window.location.replace(`${stsJumpUrl.value}comDetailLevel?id=${jumpModuleId}&topId=${customTemplateId}`)
      } else {
        window.location.replace(`${stsJumpUrl.value}comDetailLevel?id=${jumpModuleId}`)
      }
      break
    // 社区内容(帖子、文章、图册)-评论
    case '803':
      if (jumpModuleId) {
        window.location.replace(`${stsJumpUrl.value}comDetailLevel?id=${jumpModuleId}&topId=${customTemplateId}`)
      } else {
        window.location.replace(`${stsJumpUrl.value}comDetailLevel?id=${jumpModuleId}`)
      }
      break
    // 社区内容(短视频)-评论
    case '805':
      window.location.replace(`${stsJumpUrl.value}rollVideo?sortType=0&id=${jumpModuleId}&topId=${customTemplateId}`)
      break
    case '806':
      if (jumpModuleId) {
        window.location.replace(`${stsJumpUrl.value}rollVideo?sortType=0&id=${jumpModuleId}&topId=${customTemplateId}`)
      } else {
        window.location.replace(`${stsJumpUrl.value}rollVideo?sortType=0&id=${jumpModuleId}`)
      }
      break
    case '1200':
      window.location.replace(`${stsJumpUrl.value}integral`)
      break
    // 证书
    case '1202':
      window.location.replace(`${stsJumpUrl.value}certificateDetail?id=${jumpModuleId}`)
      break
    case '1101':
      window.location.replace(`${stsJumpUrl.value}applyDetail?id=${jumpModuleId}`)
      break
    case '1400':
      window.location.replace(`${stsJumpUrl.value}examPractiseInfo?practiseId=${jumpModuleId}`)
      break
    case '1500':
      window.location.replace(`${stsJumpUrl.value}lecturerDetail?lecturerId=${jumpModuleId}`)
      break
    case '1501':
      window.location.replace(`${stsJumpUrl.value}teachManage/TeachDetail?bizId=${jumpModuleId}`)
      break
    case '1502':
      window.location.replace(`${stsJumpUrl.value}teachManage/TeachManageLive?id=${jumpModuleId}`)
      break
    case '1503':
      // 员工作业批阅
      window.location.replace(
        `${stsJumpUrl.value}teachManage/HomeWorkCriticism?submitRecordId=${jumpModuleId}&reviewStatus=1&messageType='message'`
      )
      break
    case '1504':
      // 员工考试批阅
      window.location.replace(`${stsJumpUrl.value}teachManage/examReview?examId=${jumpModuleId}`)
      break
    case '1505':
      // 作业批阅
      window.location.replace(`${stsJumpUrl.value}teachManage/HomeWorkDetail?bizId=${jumpModuleId}&bizType=2402`)
      break
    case '1506':
      // 考试批阅
      window.location.replace(`${stsJumpUrl.value}teachManage/ExamViewListDetail?bizId=${jumpModuleId}&bizType=2401`)
      break
    case '1600':
      window.location.replace(`${stsJumpUrl.value}faceDetail?faceId=${jumpModuleId}`)
      break
    case '1700':
      window.location.replace(`${stsJumpUrl.value}signDetail?trainConfirmId=${jumpModuleId}`)
      break
    case '1800':
      window.location.replace(`${stsJumpUrl.value}teamStudyDetail?id=${jumpModuleId}&studyType=1`)
      break
    case '1900':
      window.location.replace(`${stsJumpUrl.value}myMedalList`)
      break
  }
}
</script>

<style lang="less" scoped></style>
